module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesUrban@2x.093ac14.webp";